import { render, staticRenderFns } from "./TerminationRevoke.vue?vue&type=template&id=60d954dc"
import script from "./TerminationRevoke.vue?vue&type=script&lang=js"
export * from "./TerminationRevoke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports